export const createDefaultQosItems = () =>
  Array.from({ length: 64 }, (_, dscp) => ({
    dscp,
    cos: null,
    defaultCos: null,
    savedCos: -1,
    modified: false,
  }));

export const normalizeQosItems = (data = {}) => {
  const dscpValues = data?.dscpValues || [];
  const defaultValues = data?.defaultValues || [];

  return createDefaultQosItems().map((defaultItem) => {
    const val = dscpValues[defaultItem.dscp] !== undefined ? dscpValues[defaultItem.dscp] : -1;
    const defaultVal = defaultValues[defaultItem.dscp] !== undefined ? defaultValues[defaultItem.dscp] : null;

    const currentCos = val !== -1 ? val : defaultVal;

    // 比較 default 與 dscp (即當前生效的 cos) 是否一樣，不一樣才是 modified
    const isModified = currentCos !== null && defaultVal !== null && currentCos !== defaultVal;

    return {
      dscp: defaultItem.dscp,
      cos: currentCos,
      defaultCos: defaultVal,
      savedCos: val,
      modified: isModified,
    };
  });
};

export const cloneQosItems = (items = []) =>
  items.map((item) => ({ ...item }));

export const isSameQosItems = (currentItems, savedItems) => {
  return currentItems.every((item, index) => {
    const savedItem = savedItems[index];

    return item.cos === savedItem.cos && item.modified === savedItem.modified;
  });
};
